import 'bootstrap/dist/css/bootstrap.min.css';
import '../3rdparty/DataTables/datatables.min.css';

import 'es6-promise/auto';
import 'bootstrap/dist/js/bootstrap';

import AppContainer from './AppContainer';
import Actions from './Actions';
import LocalStorage from './utils/LocalStorage';
import React from 'react';
import ReactDOM from 'react-dom';

let div = $('<div></div>');
$(div).attr('id', 'root');

$('body').append(div);

ReactDOM.render(
    <AppContainer />,
    $('#root')[0]
);

let state = LocalStorage.state();
Actions.start(state.user, state.token, state.landPage, state.adminPage);



// WEBPACK FOOTER //
// src/App.js